const actionType = {
  NEW_NOTIFICATIONS : 'NEW_NOTIFICATIONS'
}

export default actionType
